// TODO: should be marked as server-only
// import 'server-only';
import { cache as memoizedCache } from 'react';
import { Locale } from '@headless-workspace/config';
import { CommonDI, PersistentBannerSlotRepositoryType } from '../../../DI';

export const getMemoPersistentBannerSlot = memoizedCache((locale: Locale) =>
    CommonDI.get(PersistentBannerSlotRepositoryType).fetchPersistentBannerSlot({ locale, isPreviewable: true }),
);
